import { Component, inject } from '@angular/core';
import { CurrentContentService } from 'src/app/services/current-content.service';
import { ErrorComponent } from 'src/app/ui-components/error/error.component';
import { FullHeightContentDirective } from 'src/app/directives/full-height-content.directive';

@Component({
  selector: 'alg-page-not-found',
  templateUrl: './page-not-found.component.html',
  styleUrl: './page-not-found.component.scss',
  imports: [ FullHeightContentDirective, ErrorComponent ]
})
export class PageNotFoundComponent {
  private currentContentService = inject(CurrentContentService);

  constructor() {
    this.currentContentService.clear();
  }
}
